import Link from "next/link";
import { ContentBox } from "../../styled";
import { Container, Text } from "./styled";
import { OpenProfileButton } from "../NoLikes/styled";
import { useSelector } from "react-redux";
import { IStore } from "@Interfaces";
import React, { FC } from "react";

export const NoProfileToShow: FC = () => {
    const { self } = useSelector(({ profile }: IStore) => profile);
    return (
        <ContentBox>
            <Container>
                <Text>
                    <span>Aradığınız yaş aralığı için başka profil bulunamadı.</span>
                    <br />
                    <span>Devam etmek için profilinizden değişiklik yapabilirsiniz.</span>
                </Text>
                <Link
                    href="/profileEdit/[id]"
                    as={`/profileEdit/${self?.Id}`}
                >
                    <a>
                        <OpenProfileButton size="medium" className="mb-4">
                            PROFİLİM
                        </OpenProfileButton>
                    </a>
                </Link>
            </Container>
        </ContentBox>
    );
}
